export const colWidths = [
    100,
    100, 
    120, 
    200, 
    100
];
